
interface TagProps {
  children: string;
  selected?: boolean;
  onClick?: () => void;
  variant?: 'default' | 'category';
}

export default function Tag({ children, selected = false, onClick, variant = 'default' }: TagProps) {
  const baseClasses = 'inline-flex items-center px-3 py-1.5 rounded-md text-xs font-medium transition-colors duration-200 border';
  
  const variantClasses = {
    default: selected 
      ? 'bg-gray-800 text-white border-gray-800 dark:bg-gray-200 dark:text-gray-800 dark:border-gray-200' 
      : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 dark:hover:bg-gray-700',
    category: 'bg-gray-100 text-gray-800 border-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-600'
  };

  return (
    <span 
      className={`${baseClasses} ${variantClasses[variant]} ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      {children}
    </span>
  );
}
